import React from "react";

export default function DeleteConfirmation(
  {title, onConfirm, onCancel}
) {
  return (
    <div className="delete-confirmation">
      <p>{title}</p>
      <div style={{marginBottom: "10px", fontSize: "13px", color: "#666"}}>
        This action cannot be undone.
      </div>
      <div className="buttons">
        <button className="confirm" onClick={onConfirm}>Yes, Delete</button>
        <button className="cancel" onClick={onCancel}>No, Cancel</button>
      </div>
    </div>
  );
};
